import styled from 'styled-components';
import { theme } from '../../../../styles/theme';

export const Container = styled.div`
  width: 100%;
  max-width: 450px;
  margin: 0 auto;
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h4`
  color: ${theme.colors.secondary900};
  margin: 0;
  font-size: 14px;
  font-family: inherit;
  font-weight: 500;
  line-height: 20px;
`;

export const Period = styled.span`
  color: ${theme.colors.secondary800};
  margin-top: 4px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

export const Percentage = styled.span<{
  $isUnlimited: boolean;
  $isExceeding: boolean;
}>`
  color: ${(props) =>
    props.$isExceeding
      ? theme.colors.red500
      : props.$isUnlimited
        ? theme.colors.green400
        : theme.colors.mainBlue};
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
`;

export const ProgressContainer = styled.div`
  width: 100%;
  background-color: ${theme.colors.grayscale300};
  height: 2px;
  margin-bottom: 8px;
  margin-top: 16px;
  overflow: hidden;
`;

export const ProgressFill = styled.div<{
  $percentage: number;
  $isUnlimited: boolean;
  $isExceeding: boolean;
}>`
  height: 100%;
  width: ${(props) => props.$percentage}%;
  background-color: ${(props) =>
    props.$isUnlimited
      ? theme.colors.green400
      : props.$isExceeding
        ? theme.colors.red500
        : theme.colors.mainBlue};
  transition: width 0.3s ease;
`;

export const ValuesRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Value = styled.div`
  color: ${theme.colors.secondary900};
  font-size: 14px;
  line-height: 24px;
`;
